// extracted by mini-css-extract-plugin
export default {"container":"style_container__k6HOK","message":"style_message__H-B-q"};